import { AbServiceExperiments } from "./experiments";

export const allExperiments = [...Object.values(AbServiceExperiments)];
